import React, { useContext, useState } from 'react';
import {
  AppBar, Avatar, Box, IconButton, Snackbar, Alert, Toolbar, Typography,
} from '@mui/material';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import { useNavigate } from 'react-router-dom';
import { SidebarContext } from '../../context/SidebarContext';
import { LocationContext } from '../../context/LocationContext';
import AccountDropdown from '../Account/AccountDropdown';
import LogoutUser from '../Authorization/Logout';
import UserLocation from '../Account/UserLocation';
import { tokens } from '../../theme';

export default function AppTopbar({ logout, usrName, reload }) {
  const { toggleSidebar, isOpen } = useContext(SidebarContext);
  const { locationAccess } = useContext(LocationContext);
  const navigate = useNavigate();
  const [accntBttn, setAccntBttn] = useState(false);
  const [logoTarget, setLogoTarget] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleAcctDrop = ({ currentTarget }) => {
    setAccntBttn((v) => !v);
    setLogoTarget(currentTarget);
  };

  const handleClose = async (selection) => {
    setAccntBttn(false);
    if (selection === 'logout') {
      const { success } = await LogoutUser();
      if (success) {
        sessionStorage.removeItem('urtkn');
        return logout(true);
      }
      return setOpenSnackbar(true);
    }
    if (selection === 'settings') {
      if (isOpen) toggleSidebar();
      navigate('/account-settings/user-profile');
    }
  };

  return (
    <AppBar
      position="sticky"
      elevation={0}
      color="transparent"
      sx={{
        backgroundColor: 'rgba(255, 254, 251, 0.86)',
        backdropFilter: 'blur(10px)',
        borderBottom: `1px solid ${tokens.border}`,
        color: tokens.ink,
      }}
    >
      <Toolbar sx={{ minHeight: { xs: 64, sm: 68 }, px: { xs: 1.5, md: 2.5 }, gap: 1.5 }}>
        <IconButton
          edge="start"
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
          sx={{
            color: tokens.inkMuted,
            display: { xs: 'inline-flex', md: isOpen ? 'none' : 'inline-flex' },
            border: `1px solid ${tokens.border}`,
            borderRadius: 2,
          }}
        >
          <MenuOutlinedIcon fontSize="small" />
        </IconButton>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="body2"
            sx={{ color: tokens.inkMuted, fontWeight: 500, display: { xs: 'none', sm: 'block' } }}
          >
            Operations
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <UserLocation locationOptns={locationAccess} change={() => reload()} />
          <Box sx={{ width: '1px', height: 28, bgcolor: tokens.border, display: { xs: 'none', sm: 'block' } }} />
          <IconButton onClick={handleAcctDrop} sx={{ p: 0.5 }}>
            <Avatar
              sx={{
                width: 36,
                height: 36,
                bgcolor: tokens.accent,
                color: '#fff',
                fontWeight: 650,
                fontSize: 15,
              }}
            >
              {(usrName || '?')[0]?.toUpperCase()}
            </Avatar>
          </IconButton>
        </Box>

        {accntBttn && <AccountDropdown target={logoTarget} close={handleClose} />}
      </Toolbar>

      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity="error">
          Unable to log out!
        </Alert>
      </Snackbar>
    </AppBar>
  );
}
